import { Component, inject, OnInit, Renderer2, signal } from '@angular/core';
import {
  Data,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ModalCookiesComponent } from './core/components/modal-cookies/modal-cookies.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { filter, map } from 'rxjs';
import { HeaderComponent } from './core/components/header/header.component';
import { MobileButtonsComponent } from './core/components/mobile-buttons/mobile-buttons.component';
import { HelpBoxComponent } from './core/components/help-box/help-box.component';
import { HelpModalButtonComponent } from './core/components/help-modal-button/help-modal-button.component';
import { SpinnerComponent } from '@utilities/components/spinner/spinner.component';
import { OktaAuthStateService } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';
import { AsyncPipe } from '@angular/common';
import { AuthService } from './auth/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ModalCookiesComponent,
    FooterComponent,
    HeaderComponent,
    MobileButtonsComponent,
    HelpBoxComponent,
    HelpModalButtonComponent,
    SpinnerComponent,
    AsyncPipe,
  ],
  template: `
    <app-mobile-buttons />
    @if ((isAuthenticated$ | async) || authService.isLoggedIn()) {
      <app-header />
    }
    <router-outlet />
    <app-modal-cookies />
    @if ((isAuthenticated$ | async) || authService.isLoggedIn()) {
      <app-footer />
      <app-help-box />
      <app-help-modal-button />
    }
    <app-spinner spinnerType="global" />
  `,
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private renderer2 = inject(Renderer2);
  authService = inject(AuthService);

  private bodyClasses: string[] = this.router.config
    .map((route) => route.data)
    .filter((data) => !!data)
    .map((d: Data) => d['bodyClass'])
    .filter((bc) => !!bc);

  private oktaStateService = inject(OktaAuthStateService);
  public isAuthenticated$ = this.oktaStateService.authState$.pipe(
    filter((s: AuthState) => !!s),
    map((s: AuthState) => s.isAuthenticated ?? false),
  );

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.urlAfterRedirects.split('/')[1]),
      )
      .subscribe({
        next: (currentUrl: string) => {
          this.bodyClasses.forEach((c) =>
            this.renderer2.removeClass(document.body, c),
          );

          const data = this.router.config.find(
            (r) => r.path === currentUrl,
          )?.data;

          if (data && data['bodyClass']) {
            this.renderer2.addClass(document.body, data['bodyClass']);
          }
        },
      });
  }
}
